import { addDays, format, isSameDay, isToday, isTomorrow } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { srLatn } from "date-fns/locale";

/** Therapists work from Serbia, so slot times are Serbian local time. */
const SLOT_TIME_ZONE = "Europe/Belgrade";

/**
 * Formats a slot date relative to the visitor's local time (browser clock).
 */
export function formatRelativeSlot(date: Date): string {
  const time = format(date, "HH:mm");
  if (isToday(date)) return `danas u ${time}`;
  if (isTomorrow(date)) return `sutra u ${time}`;
  return format(date, "EEE d. MMM 'u' HH:mm", { locale: srLatn });
}

/** Short date and time for narrow therapist recommendations. */
export function formatCompactRelativeSlot(date: Date): string {
  const time = format(date, "HH:mm");
  if (isToday(date)) return `danas u ${time}`;
  if (isTomorrow(date)) return `sutra u ${time}`;
  return `${format(date, "d. MMM", { locale: srLatn })} u ${time}`;
}

/**
 * Same output, but always evaluated in Serbian local time so the server can
 * render it without knowing the visitor's timezone. Both the slot and "now"
 * are shifted, which keeps today/tomorrow correct close to midnight.
 */
export function formatRelativeSlotInBelgrade(date: Date): string {
  const zoned = toZonedTime(date, SLOT_TIME_ZONE);
  const nowZoned = toZonedTime(new Date(), SLOT_TIME_ZONE);
  const time = format(zoned, "HH:mm");

  if (isSameDay(zoned, nowZoned)) return `danas u ${time}`;
  if (isSameDay(zoned, addDays(nowZoned, 1))) return `sutra u ${time}`;
  return format(zoned, "EEE d. MMM 'u' HH:mm", { locale: srLatn });
}
